import { ConfirmDeliveryPopup as BaseConfirmDeliveryPopup } from './common/components/ConfirmDeliveryPopup';
import { ReadOnlyProductTable } from '../../common/ReadOnlyProductTable/ReadOnlyProductTable';

export const ConfirmDeliveryPopup = ({ onDismiss, offer, onConfirm, isSubmitting, isOpen }) => {
    return (
        <BaseConfirmDeliveryPopup
            onDismiss={onDismiss}
            isOpen={isOpen}
            offer={offer}
            onConfirm={onConfirm}
            isSubmitting={isSubmitting}
        >
            <ReadOnlyProductTable
                items={offer.items}
                sampleKits={offer.samplekits}
                surcharges={offer.surcharges}
                totals={{ volume: offer.volume, price: offer.ppl, total: offer.total }}
            />
        </BaseConfirmDeliveryPopup>
    );
};
